export const getHubspotScriptSrc = (code: string) => {
  return `//js-na1.hs-scripts.com/${code}.js`
}
